import React from 'react';
import { AuditTimelineMarker } from '../AuditTimeLineMarker';

export function AuditLogSkeleton() {
  return (
    <li className="flex items-start gap-5 h-[58px]">
      <AuditTimelineMarker />

      <div className="pt-0.5 animate-pulse flex flex-col gap-2 max-md:flex-1 max-md:justify-center max-md:gap-1 max-md:pt-0">
        <div className="h-3.5 w-105 rounded bg-grey-200 max-md:h-6 max-md:w-full max-md:rounded-md max-md:bg-grey-200" />
        <div className="h-3.5 w-35 rounded bg-grey-200 max-md:h-4 max-md:w-50 max-md:rounded-md max-md:bg-grey-200" />
      </div>
    </li>
  );
}
